import React from "react";
import { ReactComponent as ChevronIcon } from "assets/images/chevron16.svg";
import * as S from "./styles";

interface ShowMoreButtonProps {
  isExpanded: boolean;
  onClick: () => void;
  children?: React.ReactNode;
  className?: string;
}

const ShowMoreButton: React.FC<ShowMoreButtonProps> = ({
  isExpanded,
  onClick,
  children = "Show more",
  className,
}) => {
  return (
    <S.Container className={className}>
      <S.Button onClick={onClick} isExpanded={isExpanded}>
        <S.ButtonText>{isExpanded ? "Show less" : children}</S.ButtonText>
        <S.ChevronWrapper isExpanded={isExpanded}>
          <ChevronIcon />
        </S.ChevronWrapper>
      </S.Button>
    </S.Container>
  );
};

export default ShowMoreButton;
